<template>
    <div>
        <v-row>
            <v-col cols="12" md="8">
                <v-card>
                    <v-progress-linear :indeterminate="loading" height="4" style="padding:0; margin:0;"></v-progress-linear>

                    <v-container style="width: 90% !important;" class="my-10">
                        <ValidationProvider :name="item.name"
                                            :rules="item.rules"
                                            mode="eager"
                                            ref="provider"
                                            v-bind:key="item.name"
                                            v-for="item in items">
                            <div slot-scope="{ errors }">
                                <v-row no-gutters>

                                    <!--Label for the form-->
                                    <v-col xs="12" md="3" style="height: 65px" class="d-flex justify-end">
                                        <div class="d-flex align-center justify-end text-right mb-2">
                                            <p class="subtitle-3 font-weight-bold text--primary"
                                               :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginTop: '5px',
                               marginRight: '15px'}">{{ item.title }}:</p>
                                        </div>
                                    </v-col>

                                    <!-- Text field -->
                                    <v-col xs="12" md="9" >
                                        <v-text-field dense
                                                      :name="item.name"
                                                      outlined
                                                      :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno..' : ''"
                                                      :prepend-icon="item.icon"
                                                      v-if="item.tag === 'input' && item.name != 'jmbg'"
                                                      v-model="form[item.name]">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </ValidationProvider>
                    </v-container>

                </v-card>
            </v-col>

            <v-col cols="12" md="4" >
                <div class="fix-element">
                    <v-btn @click="saveResource()" color="primary" dark block width="100%">
                        Potvrdi
                    </v-btn>

                    <v-btn @click="goBack()" class="mt-4" color="primary" dark block outlined>
                        Odustani
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {serverBus} from "../../main";
    import ApiV2 from '@/services/ApiV2'

    import {extend, setInteractionMode, ValidationProvider} from 'vee-validate';
    import {digits, email, max, min, required} from 'vee-validate/dist/rules';

    export default {

        components: {
            ValidationProvider
        },

        props: [
            'customTable'
        ],

        created: function () {
            setInteractionMode('eager');

            extend('min', min);
            extend('max', max);
            extend('digits', digits);
            extend('email', email);
            extend('required', {...required, message: 'Ovo polje je obavezno.'});

            this.table = 'zupanija';
            this.resource.id = this.$route.params.resource_id;

            this.getGeneralData();

            setTimeout(function () {
                serverBus.$emit('get-add-view-data');
            }, 30);

            let self = this;
            serverBus.$on('perform-action-after-save', function () {
                self.$navigate('/admin/zupanija');
            });


            this.getResource();
            this.getResourceFormData();

            this.tableActive = this.table;
        },

        methods: {
            saveItem() {
                serverBus.$emit('save-add-view-data');
            },

            getGeneralData() {
                this.$axios.post(this.table + '/opcenito').then(response => {
                    this.breadcrumbs = response.data['breadcrumbs'];
                    this.breadcrumbs.push({text: 'New item'})

                    if (this.title === '') {
                        this.title = response.data['title'];
                    }
                });
            },
            getResourceFormData() {
                if (this.table === this.tableActive) return;

                this.$axios.post(this.table + '/obrazac').then(response => {
                    this.items = response.data;
                });
            },

            getResource() {
                if (this.resource.id == null || this.resource.id === -1) return;

                ApiV2.get(`cantons/${this.resource.id}`, {
                    params: {
                        with: 'diplomaSemesterFile'
                    }
                })
                    .then(response => {
                        this.form = response.data;
                    });
            },

            saveResource() {
                this.loading = true;
                 
                ApiV2.put(`cantons/${this.resource.id}`, this.form).then(() => {
                    serverBus.$emit('show-snackbar');

                    this.form = {};

                    serverBus.$emit('perform-action-after-save');
                }).catch(function (error) {
                    if (error.response.status == 422) {
                        for (let key in error.response.data.errors) {
                            serverBus.$emit('show-snackbar', false, error.response.data.errors[key][0]);
                        }
                    } else {
                        serverBus.$emit('show-snackbar', false);
                    }

                }).finally(() => {
                    serverBus.$emit('reload-all-data');

                    this.loading = false;
                });
            },

            goBack(){
                this.$router.go(-1);
            }
        },

        beforeDestroy() {
            serverBus.$off('perform-action-after-save');
        },

        data: function () {
            return {
                loading: false,
                breadcrumbs: [],
                id: '',
                table: '',
                title: '',
                resource: {},
                form: {},
                items: [],
                tableActive: '',
            }
        },
    }
</script>

<style>
    .fix-element {
        position: -webkit-sticky;
        position: sticky;
        top: 5rem;
        align-self: flex-start;
    }
</style>
